// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Couverture geographique prestataire par lot technique (modale annuaire).
   Meme habillage que l'apercu d'affectation (gestion d'equipe) : champ + toggle + carte bornee. */
.prestataire-lot-map {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.prestataire-lot-map-bar {
  display: flex;
  align-items: flex-end;
  gap: 1.5rem;
  flex-wrap: wrap;
}

/* Champ "Lot technique" : label au-dessus du select (comme la gestion d'equipe). */
.prestataire-lot-field {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}
.prestataire-lot-field span {
  font-size: 1.2rem;
  font-weight: 600;
  color: #595959;
}
.prestataire-lot-field select {
  min-width: 24rem;
  padding: 0.7rem 0.9rem;
  border: 1px solid #d1d5db;
  border-radius: 0.6rem;
  font-size: 1.3rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  cursor: pointer;
}
.prestataire-lot-field select:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
}

.prestataire-lot-map-bar .view-switch {
  margin-left: auto;
  align-self: flex-end;
}

.prestataire-lot-map-count {
  font-size: 1.25rem;
  color: #6b7280;
}

/* Carte bornee + centree : meme taille que l'apercu d'affectation (420px). */
.prestataire-lot-mapcard {
  display: flex;
  justify-content: center;
  padding: 1.4rem;
  background: #fafbfc;
  border: 1px solid #eef0f2;
  border-radius: 1rem;
}
.prestataire-lot-mapcard > * {
  width: 100%;
  max-width: 420px;
}

/* Mode liste : departements couverts (scroll interne si longue). */
.prestataire-lot-list {
  max-height: 42rem;
  overflow-y: auto;
  border: 1px solid #eef0f2;
  border-radius: 1rem;
}
.prestataire-lot-list-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.8rem 1.2rem;
  border-bottom: 1px solid #f1f3f5;
  font-size: 1.25rem;
  color: #374151;
}
.prestataire-lot-list-row:last-child {
  border-bottom: none;
}

/* Tag titulaire / libre dans la liste. */
.prestataire-lot-tag {
  flex-shrink: 0;
  padding: 0.2rem 0.7rem;
  border-radius: 999px;
  font-size: 1.05rem;
  font-weight: 600;
}
.prestataire-lot-tag.is-libre {
  background: rgba(249, 115, 22, 0.12);
  color: #c2410c;
}
.prestataire-lot-tag.is-titulaire {
  background: rgba(194, 65, 12, 0.14);
  color: #9a3412;
}

/* Legende : titulaire (accord-cadre) vs intervention libre. */
.prestataire-lot-legende {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
}
.prestataire-lot-legende-item {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.2rem;
  color: #374151;
}
.prestataire-lot-pastille {
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 0.3rem;
  border: 1px solid rgba(0, 0, 0, 0.12);
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/composants/PerimetreSelector/PrestataireLotMap.css"],"names":[],"mappings":"AAAA;kGACkG;AAClG;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;;AAEA,mFAAmF;AACnF;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,qCAAqC;EACrC,cAAc;AAChB","sourcesContent":["/* Couverture geographique prestataire par lot technique (modale annuaire).\n   Meme habillage que l'apercu d'affectation (gestion d'equipe) : champ + toggle + carte bornee. */\n.prestataire-lot-map {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.prestataire-lot-map-bar {\n  display: flex;\n  align-items: flex-end;\n  gap: 1.5rem;\n  flex-wrap: wrap;\n}\n\n/* Champ \"Lot technique\" : label au-dessus du select (comme la gestion d'equipe). */\n.prestataire-lot-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n.prestataire-lot-field span {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #595959;\n}\n.prestataire-lot-field select {\n  min-width: 24rem;\n  padding: 0.7rem 0.9rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.6rem;\n  font-size: 1.3rem;\n  font-family: inherit;\n  color: #374151;\n  background: #ffffff;\n  cursor: pointer;\n}\n.prestataire-lot-field select:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);\n}\n\n.prestataire-lot-map-bar .view-switch {\n  margin-left: auto;\n  align-self: flex-end;\n}\n\n.prestataire-lot-map-count {\n  font-size: 1.25rem;\n  color: #6b7280;\n}\n\n/* Carte bornee + centree : meme taille que l'apercu d'affectation (420px). */\n.prestataire-lot-mapcard {\n  display: flex;\n  justify-content: center;\n  padding: 1.4rem;\n  background: #fafbfc;\n  border: 1px solid #eef0f2;\n  border-radius: 1rem;\n}\n.prestataire-lot-mapcard > * {\n  width: 100%;\n  max-width: 420px;\n}\n\n/* Mode liste : departements couverts (scroll interne si longue). */\n.prestataire-lot-list {\n  max-height: 42rem;\n  overflow-y: auto;\n  border: 1px solid #eef0f2;\n  border-radius: 1rem;\n}\n.prestataire-lot-list-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.8rem 1.2rem;\n  border-bottom: 1px solid #f1f3f5;\n  font-size: 1.25rem;\n  color: #374151;\n}\n.prestataire-lot-list-row:last-child {\n  border-bottom: none;\n}\n\n/* Tag titulaire / libre dans la liste. */\n.prestataire-lot-tag {\n  flex-shrink: 0;\n  padding: 0.2rem 0.7rem;\n  border-radius: 999px;\n  font-size: 1.05rem;\n  font-weight: 600;\n}\n.prestataire-lot-tag.is-libre {\n  background: rgba(249, 115, 22, 0.12);\n  color: #c2410c;\n}\n.prestataire-lot-tag.is-titulaire {\n  background: rgba(194, 65, 12, 0.14);\n  color: #9a3412;\n}\n\n/* Legende : titulaire (accord-cadre) vs intervention libre. */\n.prestataire-lot-legende {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n}\n.prestataire-lot-legende-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1.2rem;\n  color: #374151;\n}\n.prestataire-lot-pastille {\n  width: 1.4rem;\n  height: 1.4rem;\n  border-radius: 0.3rem;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
